import { vmsDisplayName } from '_store/pmv/pmvsTypes';
import { useLocalization } from '@fluent/react';
import React, { FC } from 'react';
import { Tooltip } from 'react-leaflet';

import styles from '../styles';
import { HoveringPMV, HoverTooltipProps } from './types';

const PmvInfoTooltip: FC<HoverTooltipProps> = ({ hoveringElement }) => {
  const classes = styles();
  const { l10n } = useLocalization();
  const { vms } = hoveringElement as HoveringPMV;

  return (
    <Tooltip direction="top" sticky>
      <div className={classes.inlineHeader}>
        <div style={{ marginBottom: '0.3rem' }} className={classes.tooltipHeader}>
          {vmsDisplayName(vms)}
        </div>
      </div>
      <table>
        <tbody>
          <tr>
            <th className={classes.tooltipTableHeader}>
              {l10n.getString('forms-pmv-detail-vms-id')}
            </th>
            <td>{vms.id}</td>
          </tr>
          <tr>
            <th className={classes.tooltipTableHeader}>
              {l10n.getString('forms-pmv-detail-description')}
            </th>
            <td>{vms.description}</td>
          </tr>
        </tbody>
      </table>
    </Tooltip>
  );
};

export default PmvInfoTooltip;
